import type { LucideIcon } from "lucide-react";
import {
  Banknote,
  CheckCircle2,
  FileText,
  FolderOpen,
  Handshake,
  Mail,
  MessageSquare,
  Scale,
  Signature,
} from "lucide-react";

export interface TaskCategoryConfig {
  id: number;
  name: string;
  displayName: string;
  icon: LucideIcon;
  colorClass: string;
  iconColorClass: string;
}

/** Verbatim port of utils/config/constants/task-categories.ts (Vue). */
export const TASK_CATEGORIES: Record<string, TaskCategoryConfig> = {
  OTHER: {
    id: 1,
    name: "OTHER",
    displayName: "Autres",
    icon: FolderOpen,
    colorClass: "bg-white text-gray-700 border-gray-200",
    iconColorClass: "text-gray-500",
  },
  DOCUMENT_REQUEST: {
    id: 2,
    name: "DOCUMENT_REQUEST",
    displayName: "Demande de document",
    icon: FileText,
    colorClass: "bg-white text-gray-700 border-gray-200",
    iconColorClass: "text-blue-500",
  },
  INFORMATION_REQUEST: {
    id: 3,
    name: "INFORMATION_REQUEST",
    displayName: "Demande d'information",
    icon: MessageSquare,
    colorClass: "bg-white text-gray-700 border-gray-200",
    iconColorClass: "text-purple-500",
  },
  VERIFY_SERVICE: {
    id: 4,
    name: "VERIFY_SERVICE",
    displayName: "Vérifier Signification",
    icon: Mail,
    colorClass: "bg-white text-gray-700 border-gray-200",
    iconColorClass: "text-orange-500",
  },
  ELIGIBILITY: {
    id: 5,
    name: "ELIGIBILITY",
    displayName: "Éligibilité",
    icon: CheckCircle2,
    colorClass: "bg-white text-gray-700 border-gray-200",
    iconColorClass: "text-green-500",
  },
  SIGNATURE: {
    id: 6,
    name: "SIGNATURE",
    displayName: "Signature",
    icon: Signature,
    colorClass: "bg-white text-gray-700 border-gray-200",
    iconColorClass: "text-yellow-500",
  },
  COURT: {
    id: 7,
    name: "COURT",
    displayName: "Contentieux",
    icon: Scale,
    colorClass: "bg-white text-gray-700 border-gray-200",
    iconColorClass: "text-red-500",
  },
  MEDIATION: {
    id: 8,
    name: "MEDIATION",
    displayName: "Médiation",
    icon: Handshake,
    colorClass: "bg-white text-gray-700 border-gray-200",
    iconColorClass: "text-indigo-500",
  },
  PAYMENTS: {
    id: 9,
    name: "PAYMENTS",
    displayName: "Paiements",
    icon: Banknote,
    colorClass: "bg-white text-gray-700 border-gray-200",
    iconColorClass: "text-emerald-500",
  },
};

export const getTaskCategoryById = (id: number | null | undefined): TaskCategoryConfig | null => {
  if (!id) {
    return null;
  }

  return Object.values(TASK_CATEGORIES).find((cat) => cat.id === id) || null;
};

export const getTaskCategoryByName = (name: string): TaskCategoryConfig | null => {
  return TASK_CATEGORIES[name] || null;
};
